// Auto-generated translation for de.
// Source: landings.js, translated via Claude Sonnet on 2026-05-26T11:03:12.485595+00:00.

export const LANDINGS = {
  "eigen-paard": {
    slug: "eigen-paard",
    eyebrow: "Für Pferdebesitzer",
    title: "Alles für dein Pferd. In einer App.",
    subtitle: "Verwalte Gesundheit, Training, Planung und Fachleute in einer übersichtlichen Akte.",
    primaryCTA: {
      label: "Kostenlos starten",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Premium ansehen",
      href: "/premium",
    },
    heroScreenshot: {
      url: "/assets/owner-horse.png",
      alt: "Pferdeprofil — Gewicht, Impfung, EquiCoach, Ernährung und Training in einem Bildschirm",
      caption: "Dein Pferd, vollständig im Blick.",
    },
    problem: "Termine, Fotos, Training, Ernährung und Gesundheit verwaltest du wahrscheinlich an verschiedenen Orten — in WhatsApp-Gruppen, Schuhkartons und einzelnen Apps. Dadurch verlierst du den Überblick.",
    solution: "EquiSight verwandelt dein Pferd in eine vollständige digitale Akte, die immer bei dir ist.",
    benefits: [
      "Ein vollständiges Pferdeprofil pro Pferd",
      "Gesundheit, Hufschmied, Zahnarzt und Physiotherapeut an einem Ort",
      "Kalender mit intelligenten Erinnerungen",
      "Fotos, Notizen und Verlauf ohne Limit",
      "Datensicherung aller Informationen bei Premium",
    ],
    pricing: {
      tiers: [
        {
          name: "Basic",
          price: "€0",
          note: "1 Pferd · immer kostenlos",
        },
        {
          name: "Premium",
          price: "€4,99",
          note: "Mehrere Pferde + Datensicherung",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Bereit für den Start?",
      title: "Beginne noch heute mit deinem ersten Pferd.",
      href: "/#waitlist",
    },
  },
  "premium": {
    slug: "premium",
    eyebrow: "Premium",
    title: "Mehr Pferde. Mehr Überblick. Mehr Sicherheit.",
    subtitle: "Upgrade auf Premium und verwalte alle deine Pferde ohne Einschränkungen — mit der vollen EquiCoach Intelligence.",
    primaryCTA: {
      label: "14 Tage kostenlos starten",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Alle Preise",
      href: "/#pricing",
    },
    audience: "Für Besitzer, Sportreiter und Pferdehalter mit mehreren Pferden.",
    features: [
      "Unbegrenzt Pferde hinzufügen",
      "Vollständige Historie pro Pferd",
      "Datensicherung",
      "Umfassende EquiCoach Einblicke",
      "Intelligente Benachrichtigungen und Planung",
      "Gesundheit und Training vollständig verknüpft",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Weniger als €0,17 pro Tag",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Bereit?",
      title: "Upgrade auf Premium.",
      href: "/#waitlist",
    },
  },
  "manege-ruiter": {
    slug: "manege-ruiter",
    eyebrow: "Für Reithallen-Reiter",
    title: "Besser werden – auch ohne eigenes Pferd.",
    subtitle: "Verfolge deine Lektionen, Trainings und Entwicklung in EquiSight — für weniger als eine Tasse Kaffee pro Monat für Papa oder Mama. Oder ein leckeres Eis mit Sahne.",
    primaryCTA: {
      label: "Mit Premium starten",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Wie funktioniert es?",
      href: "#features",
    },
    problem: "Als Reithallen-Reiter hast du oft kein eigenes Pferd, möchtest aber trotzdem wachsen und den Überblick über deine Lektionen, Ziele und die Pferde, auf denen du reitest, behalten.",
    solution: "Die Reithallen-Funktionalität ist standardmäßig in Premium enthalten — verfolge deine eigene Entwicklung und sieh dir die verknüpften Reithallenpferde im Lesezugriff an.",
    features: [
      "Trainings erfassen",
      "Ziele setzen",
      "Fortschritt verfolgen",
      "Reithallenpferde mit Name und Foto anzeigen",
      "Kein Zugriff auf private Gesundheitsdaten",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Pro Monat · Reithallen-Funktionalität inklusive",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Mitglied werden",
      title: "Als Reithallen-Reiter starten.",
      href: "/#waitlist",
    },
  },
  "manege-module": {
    slug: "manege-module",
    eyebrow: "Für Reitzentren & Ställe",
    title: "Mach dein Reitzentrumdigital zugänglich für jeden Reiter.",
    subtitle: "Gib Reitern eine Verbindung zu Pferden, Lektionen und Fortschritt — ohne sensible Stalldaten zu teilen.",
    primaryCTA: {
      label: "Zugang anfragen",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Module ansehen",
      href: "#features",
    },
    audience: "EquiSight hilft Reitzentren und Ställen, Reiter länger zu binden und sich digital abzuheben.",
    features: [
      "Schulpferde für Reiter sichtbar machen",
      "Name und Foto pro Pferd",
      "Reiter mit Pferden verknüpfen",
      "Nur-Lese-Zugriff für datenschutzsensible Daten",
      "Lektions- und Trainingshistorie zentral erfassen",
      "Benutzerverwaltung mit Rollen",
    ],
    benefits: [
      "Stärkere Bindung zu Reitern",
      "Professionelleres Erscheinungsbild",
      "Zusätzlicher digitaler Service für Mitglieder",
      "Neue Einnahmequelle durch App-Nutzung",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Pro Monat · Reitzentrumfunktionalität für Reiter inbegriffen",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Bereit?",
      title: "Reitzentrums-Modul aktivieren.",
      href: "/#waitlist",
    },
  },
  "fokkerij": {
    slug: "fokkerij",
    eyebrow: "Zuchtmodul",
    title: "Kontrolle über Zyklus, Trächtigkeit und Fohlenentwicklung.",
    subtitle: "Das vollständige Zuchtmodul für Stutenhalterin und Züchter — von der Bedeckung bis zum Fohlen, in einer Zeitlinie.",
    primaryCTA: {
      label: "Zuchtmodul aktivieren",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Funktionen ansehen",
      href: "#features",
    },
    audience: "Für Züchter, Stutenhalter und Ställe, die mehrere Stuten verwalten.",
    features: [
      "Zyklusverfolgung",
      "Rossigkeit erfassen",
      "Besamungsdaten festhalten",
      "Countdown bis zur Ultraschalluntersuchung",
      "Trächtigkeitskontrollen planen",
      "Stammbaum und Abstammung",
      "Fohlenentwicklung",
      "Übersicht aller trächtigen Stuten",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Pro Monat · Zuchtmodul in Pro enthalten",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Heute starten",
      title: "Mit dem Zuchtmanagement beginnen.",
      href: "/#waitlist",
    },
  },
  "hoefsmid": {
    slug: "hoefsmid",
    eyebrow: "Hufschmied-Modul",
    title: "Arbeiten Sie smarter als Hufschmied. Alles professionell dokumentieren.",
    subtitle: "Terminkalender, Fotos, Notizen und Behandlungshistorie in einem Modul — weniger Missverständnisse, stärkere Dokumentation.",
    primaryCTA: {
      label: "Als Hufschmied starten",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Professional Bundle ansehen",
      href: "/professional",
    },
    audience: "Für Hufschmiede, die Überblick, Nachweisführung und Kundenkommunikation verbessern möchten.",
    features: [
      "Eigener Terminkalender",
      "Termine pro Kunde",
      "Pferdeprofile einsehen",
      "Vorher- und Nachher-Fotos hinzufügen",
      "Behandlung dokumentieren",
      "Empfehlungen und Notizen festhalten",
      "ETA-Benachrichtigung an den Kunden: \"Der Hufschmied ist unterwegs\"",
    ],
    benefits: [
      "Professioneller arbeiten",
      "Weniger Missverständnisse",
      "Bessere Dokumentation",
      "Stärkere Position bei Haftungsfragen",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Pro Monat · Hufschmied-Modul im Professional enthalten",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Bereit?",
      title: "Hufschmied-Modul aktivieren.",
      href: "/#waitlist",
    },
  },
  "paardentandarts": {
    slug: "paardentandarts",
    eyebrow: "Zahnarzt-Modul",
    title: "Eine vollständige Zahndokumentation pro Pferd.",
    subtitle: "Erfassen Sie Befunde, Behandlungen und Nachsorge direkt in EquiSight.",
    primaryCTA: {
      label: "Als Pferdezahnarzt starten",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Professional-Paket ansehen",
      href: "/professional",
    },
    audience: "Pferdezahnärzte, Tierärzte und Praxen, die strukturiert arbeiten möchten.",
    features: [
      "Gebissuntersuchung erfassen",
      "Befunde pro Behandlung",
      "Fotos hinzufügen",
      "Bericht an den Eigentümer",
      "Nachsorgeempfehlung",
      "Historie pro Pferd",
      "Neuen Termin planen",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Pro Monat · Zahnarzt-Modul im Professional-Paket enthalten",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Bereit?",
      title: "Zahnarzt-Modul aktivieren.",
      href: "/#waitlist",
    },
  },
  "fysio-osteo": {
    slug: "fysio-osteo",
    eyebrow: "Physio / Osteo Modul",
    title: "Körper, Bewegung und Erholung professionell verfolgen.",
    subtitle: "Für Physiotherapeuten und Osteopathen, die Pferde strukturiert begleiten möchten.",
    primaryCTA: {
      label: "Als Physio/Osteo starten",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Professional Paket ansehen",
      href: "/professional",
    },
    features: [
      "Aufnahme pro Pferd",
      "Körperbefunde erfassen",
      "Fotos und Videos hinzufügen",
      "Behandlungsbericht erstellen",
      "Übungen und Nachverfolgung teilen",
      "Genesungsverlauf verfolgen",
      "Verlauf pro Pferd",
    ],
    benefits: [
      "Bessere Erkenntnisse über die Zeit",
      "Professionelle Berichterstattung",
      "Klare Kommunikation mit Besitzer, Trainer und Reiter",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Pro Monat · Physio / Osteo Modul im Professional enthalten",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Bereit?",
      title: "Physio / Osteo Modul aktivieren.",
      href: "/#waitlist",
    },
  },
  "trainer": {
    slug: "trainer",
    eyebrow: "Trainer-Modul",
    title: "Coache Reiter mit Daten, Zielen und Fortschritt.",
    subtitle: "Mache das Training messbar und die Begleitung professioneller — für einen oder mehrere Reiter.",
    primaryCTA: {
      label: "Als Trainer starten",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Pro-Paket ansehen",
      href: "/#pricing",
    },
    audience: "Für Instrukteure, Trainer und Coaches mit mehreren Reitern oder Pferden.",
    features: [
      "Reiter verknüpfen",
      "Pferde verfolgen",
      "Trainingsziele festlegen",
      "Feedback geben",
      "Wettkampfergebnisse analysieren",
      "Fortschritt pro Kombination einsehen",
      "Protokollanalysen für den Trainingsfokus nutzen",
    ],
    benefits: [
      "Bessere Begleitung",
      "Mehr Struktur",
      "Professionellere Kommunikation",
      "Stärkere Kundenbindung",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Pro Monat · Trainer-Modul im Pro-Paket enthalten",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Bereit?",
      title: "Trainer-Modul aktivieren.",
      href: "/#waitlist",
    },
  },
  "wedstrijdanalyse": {
    slug: "wedstrijdanalyse",
    eyebrow: "Wettkampfanalyse",
    title: "Vom Protokoll zur Leistungsverbesserung.",
    subtitle: "Lade dein Wettkampfprotokoll hoch und entdecke, wo du Punkte liegenlässt — nicht nur deine Note ansehen, sondern verstehen, wie du besser wirst.",
    primaryCTA: {
      label: "Analysiere dein erstes Protokoll",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Premium ansehen",
      href: "/premium",
    },
    features: [
      "Protokollfoto hochladen",
      "Vorder- und Rückseite verarbeiten",
      "Klasse, Aufgabennummer und Richter erkennen",
      "Noten pro Teilaufgabe analysieren",
      "Kommentare zusammenfassen",
      "Stärken und Schwächen anzeigen",
      "Trends pro Pferd-Reiter-Kombination",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Pro Monat · Wettkampfanalyse ab Premium inbegriffen",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Bereit?",
      title: "Starte mit der Wettkampfanalyse.",
      href: "/#waitlist",
    },
  },
  "professional": {
    slug: "professional",
    eyebrow: "Professional-Paket",
    title: "Für Profis rund ums Pferd.",
    subtitle: "Hufschmied, Zahnarzt, Physiotherapeut, Osteopath oder Trainer: Arbeiten Sie gemeinsam in einer digitalen Pferdedokumentation.",
    primaryCTA: {
      label: "Als Professional starten",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Einzelne Module ansehen",
      href: "#features",
    },
    audience: "Das Professional-Paket kombiniert alle Fachmodule in einem einzigen Abonnement.",
    features: [
      "Hufschmied-Modul",
      "Zahnarzt-Modul",
      "Physio / Osteo-Modul",
      "Kalender & Kundenverwaltung",
      "Pferdeprofile & Berichte",
      "Behandlungshistorie & Dokumentenaufbau",
      "Kommunikation mit dem Eigentümer",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Pro Monat · alle Fachmodule inbegriffen",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Bereit?",
      title: "Professional wählen.",
      href: "/#waitlist",
    },
  },
  "noodnummerpaard": {
    slug: "noodnummerpaard",
    eyebrow: "Notfallnummern Pferd",
    title: "Immer die richtige Hilfe griffbereit.",
    subtitle: "In einem Notfall zählt jede Sekunde. Mit EquiSight hast du alle wichtigen Kontaktdaten deines Pferdes sofort zur Hand — ein Tipp und du rufst an.",
    primaryCTA: {
      label: "Notfallkontakte jetzt einrichten",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Kostenlos mit EquiSight starten",
      href: "/#waitlist",
    },
    accent: "danger",
    heroScreenshot: {
      url: "/assets/emergency.png",
      alt: "Notfallkontakte — direkt anrufen, WhatsApp senden oder zum Tierarzt, zur Klinik und zum Hufschmied navigieren",
      caption: "Ein Tipp. Keine Panik suchen.",
      embeddedFrame: true,
    },
    problem: "Dein Pferd hat etwas — Kolik, Verletzung, Panik. Und dann beginnt die Suche. Wen rufst du an? Hast du die richtige Nummer? Ist das die Notfallnummer? Kostbare Zeit geht verloren.",
    solution: "Mit EquiSight hast du alles sofort zur Hand. Kein Suchen. Kein Zweifeln. Ein Tipp und du bist verbunden.",
    scenario: {
      title: "Stell dir vor — dein Pferd zeigt Kolikanzeichen.",
      steps: [
        "Du öffnest EquiSight",
        "Tippst auf \"Tierarzt\"",
        "Rufst direkt an",
      ],
      tagline: "Kein Stress. Kein Suchen. Nur Handeln.",
    },
    features: [
      "Alle Notfallnummern an einem Ort",
      "Ein-Tipp-Anrufen direkt aus der App",
      "WhatsApp mit einem Tipp senden",
      "Direkt zur Adresse navigieren",
      "Pro Pferd eigene Kontaktliste",
      "Tierarzt, Klinik, Hufschmied, Zahnarzt, Physiotherapeut",
      "Adresse + Wegbeschreibung sofort verfügbar",
      "Favoritennummern mit einem Stern markieren",
      "Notrufnummern (112, 144) immer ganz oben",
    ],
    benefits: [
      "Ruhe und Kontrolle in einer Notsituation",
      "Alle auf dem Stall haben dieselben Nummern parat",
      "Keine vergessenen Visitenkarten mehr",
      "Reagiere in Notfällen Sekunden schneller",
    ],
    audience: "Für Pferdebesitzer, Pfleger, Trainer und Ställe — alle, die Verantwortung für ein Pferd tragen.",
    showcase: {
      eyebrow: "Vorab für dich vorbereitet",
      title: "13 Kontaktkategorien — bereit zum Ausfüllen.",
      description: "Von Tierarzt und Notfallklinik bis hin zu Sattler, Reitlehrer und Weideverwalter. EquiSight kennt deine Welt und stellt die richtigen Kontaktfelder fertig für dich bereit. Tippen, ausfüllen, fertig.",
      bullets: [
        "Notfall & Gesundheit — Tierarzt, Notaufnahme, Klinik, Vergiftungshotline",
        "Tägliche Pflege — Hufschmied, Zahnarzt, Physiotherapeut, Reitlehrer",
        "Stall & Weide — Stallbetreiber, Weideverwalter, Pensionsstall",
        "Futter & Material — Heu-, Kraftfutter- und Strohlieferanten",
      ],
      image: {
        url: "/assets/emergency-manage.png",
        alt: "Notfallkontakte Verwaltungsbildschirm — alle vorgeschlagenen Kontakte nach Kategorie",
        embeddedFrame: true,
      },
    },
    checklist: {
      title: "Checkliste Notfallnummern Pferd",
      items: [
        "Tierarzt",
        "Notfallklinik (24/7)",
        "Tierambulanz · 144",
        "Hufschmied",
        "Backup-Ansprechperson",
        "Allgemeiner Notruf · 112",
      ],
      cta: {
        label: "In EquiSight öffnen und direkt ausfüllen",
        href: "/#waitlist",
      },
    },
    pricing: {
      tiers: [
        {
          name: "Notfallnummern",
          price: "Gratis",
          note: "Immer kostenlos · für alle, in jedem Abonnement",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Sei vorbereitet",
      title: "Bevor es nötig wird.",
      href: "/#waitlist",
    },
    microcopy: [
      "Keine Verpflichtungen",
      "In 2 Minuten eingerichtet",
      "Jederzeit anpassbar",
    ],
  },
};

export default LANDINGS;
